<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      short-title="cp"
      title="cabo.party"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Home',
            icon: $icons.cactus,
            path: '/',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            icon: $icons.sun,
            name: 'Today',
            path: '/los-cabos-events-today',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Clubs',
            icon: $icons.disc,
            path: '/los-cabos-clubs',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Calendar',
            icon: $icons.calendar,
            path: '/los-cabos-mexico-event-calendar',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Dinner',
            icon: $icons.utensils,
            path: '/los-cabos-dinner-table-reservations',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Nightlife',
            icon: $icons.moon,
            path: '/los-cabos-nightlife',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            icon: $icons.astronaut,
            name: 'Travel & Concierge',
            path: '/los-cabos-concierge-services',
          }"
        >
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>
      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <Transition name="fade" appear>
          <router-view></router-view>
        </Transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
  },
  data() {
    return {
      sidebarBackground: 'vue', //vue|blue|orange|green|red|primary
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('sidebar-wrapper');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}

/* Spring Break Special Link Styling */
::v-deep .spring-break-special-link {
  margin: 10px 0 !important;

  a {
    background: linear-gradient(
      135deg,
      #0a6e8f 0%,
      #f97316 50%,
      #0a6e8f 100%
    ) !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 15px rgba(249, 115, 22, 0.4) !important;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease !important;

    &::before {
      content: '';
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: linear-gradient(
        45deg,
        transparent,
        rgba(255, 255, 255, 0.3),
        transparent
      );
      transform: rotate(45deg);
      animation: shimmer 3s infinite;
    }

    &:hover {
      transform: translateY(-2px) !important;
      box-shadow: 0 6px 20px rgba(249, 115, 22, 0.6) !important;
      background: linear-gradient(
        135deg,
        #f97316 0%,
        #0a6e8f 50%,
        #f97316 100%
      ) !important;
    }

    i,
    p {
      color: #fff !important;
      font-weight: 600 !important;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
    }

    p {
      font-size: 0.95rem !important;
      letter-spacing: 0.5px !important;
    }
  }

  /* Pulsing glow animation */
  animation: pulse-glow 2s ease-in-out infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

@keyframes pulse-glow {
  0%,
  100% {
    filter: drop-shadow(0 0 5px rgba(212, 175, 55, 0.5));
  }
  50% {
    filter: drop-shadow(0 0 15px rgba(212, 175, 55, 0.8));
  }
}
</style>
